module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partners"
  }, [_c('div', {
    staticClass: "partners-heading block-heading-font-style"
  }, [_vm._v(_vm._s(_vm.partnerText.heading))]), _vm._v(" "), _c('div', {
    staticClass: "partners-subheading block-subheading-font-style"
  }, [_vm._v(_vm._s(_vm.partnerText.subheading))]), _vm._v(" "), _c('span', {
    staticClass: "partner-logos"
  }, _vm._l((_vm.partnerList), function(partner) {
    return _c('img', {
      attrs: {
        "src": _vm.getImgUrl(partner),
        "alt": "partner"
      }
    })
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07fe6791"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Partners.vue
// module id = 451
// module chunks = 0